import { scalingConfig } from './scaling'

export type Lang = 'en' | 'fr' | 'uk'

const WEB_LANGS: Lang[] = ['en', 'fr', 'uk']

function isWebLang(v: string): v is Lang {
  return WEB_LANGS.includes(v as Lang)
}

const rawAllowed = (scalingConfig.ALLOWED_LANGUAGES || []) as string[]
const filtered = rawAllowed.filter(isWebLang)

// safety fallback, чтобы никогда не остаться без языка
export const ALLOWED_LANGUAGES: Lang[] = filtered.length ? filtered : ['en']

const rawDefault = String(scalingConfig.DEFAULT_LANGUAGE || '').toLowerCase()
export const DEFAULT_LANGUAGE: Lang =
  isWebLang(rawDefault) && ALLOWED_LANGUAGES.includes(rawDefault)
    ? rawDefault
    : ALLOWED_LANGUAGES[0] || 'en'

const LABELS: Record<Lang, string> = {
  en: 'English',
  fr: 'Français',
  uk: 'Українська',
}

export const LANGUAGE_OPTIONS = ALLOWED_LANGUAGES.map((value) => ({
  value,
  label: LABELS[value],
}))
